import * as THREE from 'three'

export class InputManager{

    constructor(canvas){

        this.canvas = canvas || window;

        this.mouse = new THREE.Vector2();
        this.mousedown = new THREE.Vector2();
        this.keys = {}; 
        this.justPressed = {};

        window.addEventListener("keydown", (e) => { 
            const key = e.key.toLowerCase();
            if (!this.keys[key]) this.justPressed[key] = true;
            this.keys[key] = true; 
        });
        
        window.addEventListener("keyup", (e) => { 
            this.keys[e.key.toLowerCase()] = false; 
        });

        this.raycaster = new THREE.Raycaster();

        this.clicked = false;

        this.canvas.addEventListener("mousemove", (event) => {

            this.mouse.x =   event.clientX / window.innerWidth   * 2 - 1;
            this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        });

        this.canvas.addEventListener("mousedown", (event) => {

            this.mousedown.set(event.clientX, event.clientY);

            console.log(this.clicked + " mouse down");

        });

        this.canvas.addEventListener("mouseup", (event) => {

            const dragDistance = Math.hypot(this.mousedown.x - event.clientX, this.mousedown.y - event.clientY);

            this.clicked = dragDistance < 4;

            console.log(this.clicked + " mouse up");
        });
    }

    isKeyJustPressed(key) {
        return !!this.justPressed[key.toLowerCase()];
    }

    // Renamed from update to clear for clarity in StateManager
    clearFrameInputs() {
        this.clicked = false;
        this.justPressed = {};
    }

    getIntersections(camera, targets){

        this.raycaster.setFromCamera(this.mouse, camera);

        return this.raycaster.intersectObjects(targets, true);
    }
}